import axios from "axios";
import { Loading, Notify } from "notiflix";
import { SCHOOL_INFO, SCHOOL_LIST } from "./types";
import { APIURL } from "./config";

export const searchSchool = (keyword, cb) => async dispatch => {
   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      const res = await axios.post(`${APIURL}/api/school/searchSchool/${keyword}`, {}, config);
      if (res?.data?.status) {
         dispatch({
            type: SCHOOL_LIST,
            payload: res?.data?.data,
         });
         if (cb) cb(res?.data?.data);
      } else if (!res?.data?.status) {
         dispatch({
            type: SCHOOL_LIST,
            payload: [],
         });
         if (cb) cb([]);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const emptySearchSchool = () => (dispatch) => {
   dispatch({ type: SCHOOL_LIST, payload: [] });
};

export const getSchoolInfo = () => async dispatch => {
   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      },
      data: {}
   };
   try {
      Loading.standard();
      const res = await axios.get(`${APIURL}/api/schooladmin/info/v1`, config);
      Loading.remove();
      if (res?.status === 200) {
         dispatch({
            type: SCHOOL_INFO,
            payload: res?.data,
         });
      } else {
         dispatch({
            type: SCHOOL_INFO,
            payload: {},
         });
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const subscribeNewsletter = data => async dispatch => {
   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };

   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/subscription/subscribe`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ?? "Subscribed successfully!"
         Notify.success(message);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}